var _style, _rect, _text, _text2, _rect2, _text3, _text4, _text5, _text6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoot1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".title {fill: white; font-family: serif; font-size: 16px;}.subtitle  {fill: white; font-family: serif; font-size: 16px;}.base { fill: white; font-family: serif; font-size: 22px; }.quote { fill: black; font-family: serif; font-size: 12px; font-style = italic; }.note{fill: white; font-size: 16px;}")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "black"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "8%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    className: "base"
  }, "Swift Biosuit Sonic Blast")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "15%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    className: "title"
  }, "Common")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 140,
    fill: "floralwhite",
    x: 85,
    y: 90,
    rx: 5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "30%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    className: "quote",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    dy: "1.2em",
    x: "50%"
  }, "Moloch hired numerous guards to"), /*#__PURE__*/React.createElement("tspan", {
    dy: "1.2em",
    x: "50%"
  }, "protect this item from thieves."), /*#__PURE__*/React.createElement("tspan", {
    dy: "1.2em",
    x: "50%"
  }, "He never counted on the guards stealing."), /*#__PURE__*/React.createElement("tspan", {
    dy: "1.2em",
    x: "50%"
  }))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "65%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    className: "base"
  }, "Apparel")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "83%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    className: "subtitle"
  }, "Manufacturer: Black Hole Division")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "95%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    className: "note",
    fontStyle: "italic"
  }, "Dropped by alien named Moloch")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoot1);
export default __webpack_public_path__ + "static/media/loot1.5d148ff4.svg";
export { ForwardRef as ReactComponent };